import React, { useEffect, useMemo, useState, useContext } from "react";
import Slider from "react-slick";
import { useStaticQuery, graphql, withPrefix } from "gatsby";

// Components //
import TitleSection from "../../molecules/title-section";
import MediaCard from "../../molecules/media-card/mediaCard";
import PreviousArrowButton from "../../atoms/previous-arrow-button/previousArrowButton";
import NextArrowButton from "../../atoms/next-arrow-button/nextArrowButton";

// Context //
import GlobalContext from "../../../contexts/globalContext";

// References //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
// Styles //
import "./personasRecommended.scss";

const PersonasRecommended = (props: ReferenciaContenido) => {
    const contentfulId = props.contentful_id;
    const backgroundColor = contentfulId === "5PNSUXn02IPOHsnq8MLrhw" ? "var(--color-grey100-grey800)" : null;
    const dataBiblioteca = useStaticQuery(graphql`
        query DATABIBLIOTECA {
            contentfulSubcategorias(
                contentful_id: { eq: "7KHkTe0HcCUf8Xhn7NvwGC" }
            ) {
                referenciaSubcategorias {
                    slug
                    referenciaSubcategorias {
                        slug
                        referenciaInterna {
                            referenciaContenido {
                                contentful_id
                            }
                            referenciaCabecera {
                                migaDePan
                                referenciaMultimedia {
                                    audioUrl
                                    autor
                                    categoriaMultimedia
                                    contentful_id
                                    createdAt
                                    descripcion {
                                        raw
                                    }
                                    imagenPrincipal {
                                        gatsbyImageData(
                                            layout: CONSTRAINED
                                            outputPixelDensities: [0.5, 1, 2]
                                            breakpoints: [320, 768, 1024, 1440]
                                            placeholder: BLURRED
                                            sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                        )
                                        description
                                    }
                                    nuevoContenido
                                    tematica
                                    textoIntroductorio
                                    tiempoLectura
                                    tituloBoton
                                    tituloMultimedia
                                    videoUrl
                                    video {
                                        file {
                                            url
                                            fileName
                                            contentType
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [showContent, setShowContent] = useState<boolean>(false);
    const Context = useContext(GlobalContext);

    function getListSubcategorias(array, key) {
        return array.flatMap((obj) => {
            const subCategories = obj[key];
            const parentSlug = obj.slug;
            return subCategories.map((value) => ({
                ...value.referenciaInterna.referenciaCabecera
                    .referenciaMultimedia,
                parentSlug,
                slug: value.slug,
            }));
        });
    }

    const transformedData = useMemo(
        () =>
            getListSubcategorias(
                dataBiblioteca.contentfulSubcategorias.referenciaSubcategorias,
                "referenciaSubcategorias"
            ),
        []
    );
    const getLastTrend = (array) => {
        return array
            .map((obj) => {
                return { ...obj, date: new Date(obj.createdAt) };
            })
            .sort((a: any, b: any) => b.date - a.date);
    };

    const CarouselGeneral = {
        customPaging: (i) => <div className={`line line-${i}`}>──</div>,
        dots: props.contentful_id != "5PNSUXn02IPOHsnq8MLrhw",
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 3,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 3;

    useEffect(() => {
        if (
            Context?.gigyaContext?.gigyaAccount ||
            props.filtroTematica == "podcastView"
        )
            setShowContent(true);
        else {
            setShowContent(true);
        }
    }, [Context.gigyaContext.gigyaAccount]);

    return (
        <>
            {showContent ? (
                <div className="o-personas-recommended" style={{ backgroundColor }}>
                    <div className="container">
                        <div className={`o-personas-recommended__inner ${props.contentful_id === "5PNSUXn02IPOHsnq8MLrhw" ? "center-titleInner" : ""}`}>
                            <div className={`o-personas-recommended ${props.contentful_id === "5PNSUXn02IPOHsnq8MLrhw" ? "center-title" : ""}`}>
                                <TitleSection
                                    title={
                                        props.filtroTematica === "podcastView"
                                            ? "También te puede interesar..."
                                            : props.filtroTematica
                                                ? "Recomendados para ti"
                                                : props.tituloGeneral
                                    }
                                />
                            </div>
                            <div className="o-personas-recommended__slider">
                                {props.contentful_id !== "5PNSUXn02IPOHsnq8MLrhw" && (
                                    <div className="arrows-slider">
                                        <PreviousArrowButton canGoPrev={isActiveBack()} onClick={goToBack}/>
                                        <NextArrowButton canGoNext={isActiveNext()} onClick={goToNext}/>
                                    </div>
                                )}
                                <Slider
                                    ref={(c) => {
                                        setSlider(c);
                                    }}
                                    {...CarouselGeneral}
                                >
                                    {getLastTrend(transformedData)
                                        .slice(0, 6)
                                        .map((item, i) => (
                                            <MediaCard
                                                key={i}
                                                tituloMultimedia={
                                                    item.tituloMultimedia
                                                }
                                                descripcion={item.descripcion}
                                                imagenPrincipal={
                                                    item.imagenPrincipal
                                                }
                                                tituloBoton={item.tituloBoton}
                                                tematica={item.tematica}
                                                categoriaMultimedia={
                                                    item.categoriaMultimedia
                                                }
                                                nuevoContenido={
                                                    item.nuevoContenido
                                                }
                                                textoIntroductorio={
                                                    item.textoIntroductorio
                                                }
                                                slug={`biblioteca/${item.parentSlug}${item.slug}`}
                                                parentContentfulId={
                                                    item.parentContentfulId
                                                }
                                                createdAt={item.createdAt}
                                            />
                                        ))}
                                </Slider>
                            </div>
                        </div>
                        { (props.contentful_id === '5PNSUXn02IPOHsnq8MLrhw' || props.contentful_id === '1oEjckowQVL3rtNuazQ3Yq') && (
                        <div className="o-personas-recommended__button">
                        <Button
                            type="link"
                            text={props.tituloBoton}
                            classname={`a-button__magenta`}
                            isDisabled={false}
                            href={props.redireccionBoton}
                        />
                         </div>
                    )}
                    </div>
                </div>
            ) : null}
        </>
    );


};

export default PersonasRecommended;
